import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './team1.css'

const Team1 = (props) => {
  const TitleTag = props.titleAs
  return (
    <div className="team1-thq-team8-elm thq-section-padding">
      <div className="team1-thq-max-width-elm thq-section-max-width">
        <div className="team1-thq-section-title-elm">
          <div className="team1-thq-content-elm1">
            <TitleTag className="team1-thq-text-elm10 thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="team1-text24">Our team</span>
                </Fragment>
              )}
            </TitleTag>
            <p className="team1-thq-text-elm11 thq-body-large">
              {props.content2 ?? (
                <Fragment>
                  <span className="team1-text26">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="team1-thq-content-elm2">
          <div className="team1-thq-content-elm3">
            <div className="team1-thq-row-elm1">
              <div className="team1-thq-card-elm1">
                <img
                  alt={props.member1Alt}
                  loading="lazy"
                  src={props.member1Src}
                  className="thq-img-ratio-1-1 team1-thq-placeholder-image-elm1"
                />
                <div className="team1-thq-content-elm4">
                  <div className="team1-thq-title-elm1">
                    <span className="team1-thq-text-elm12 thq-body-small">
                      {props.member1 ?? (
                        <Fragment>
                          <span className="team1-text27">Full name</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team1-thq-text-elm13 thq-body-small">
                      {props.member1Job ?? (
                        <Fragment>
                          <span className="team1-text16">Job title</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team1-thq-text-elm14 thq-body-small">
                    {props.member1Content ?? (
                      <Fragment>
                        <span className="team1-text11">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Suspendisse varius enim in eros elementum
                          tristique.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team1-thq-social-icons-elm1">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
              <div className="team1-thq-card-elm2">
                <img
                  alt={props.member2Alt}
                  loading="lazy"
                  src={props.member2Src}
                  className="thq-img-ratio-1-1 team1-thq-placeholder-image-elm2"
                />
                <div className="team1-thq-content-elm5">
                  <div className="team1-thq-title-elm2">
                    <span className="team1-thq-text-elm15 thq-body-small">
                      {props.member2 ?? (
                        <Fragment>
                          <span className="team1-text12">Full name</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team1-thq-text-elm16 thq-body-small">
                      {props.member2Job ?? (
                        <Fragment>
                          <span className="team1-text28">Job title</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team1-thq-text-elm17 thq-body-small">
                    {props.member2Content ?? (
                      <Fragment>
                        <span className="team1-text14">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Suspendisse varius enim in eros elementum
                          tristique.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team1-thq-social-icons-elm2">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
              <div className="team1-thq-card-elm3">
                <img
                  alt={props.member3Alt}
                  loading="lazy"
                  src={props.member3Src}
                  className="thq-img-ratio-1-1 team1-thq-placeholder-image-elm3"
                />
                <div className="team1-thq-content-elm6">
                  <div className="team1-thq-title-elm3">
                    <span className="team1-thq-text-elm18 thq-body-small">
                      {props.member3 ?? (
                        <Fragment>
                          <span className="team1-text19">Full name</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team1-thq-text-elm19 thq-body-small">
                      {props.member3Job ?? (
                        <Fragment>
                          <span className="team1-text21">Job title</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team1-thq-text-elm20 thq-body-small">
                    {props.member3Content ?? (
                      <Fragment>
                        <span className="team1-text15">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Suspendisse varius enim in eros elementum
                          tristique.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team1-thq-social-icons-elm3">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div className="team1-thq-row-elm2">
              <div className="team1-thq-card-elm4">
                <img
                  alt={props.member4Alt}
                  loading="lazy"
                  src={props.member4Src}
                  className="thq-img-ratio-1-1 team1-thq-placeholder-image-elm4"
                />
                <div className="team1-thq-content-elm7">
                  <div className="team1-thq-title-elm4">
                    <span className="team1-thq-text-elm21 thq-body-small">
                      {props.member4 ?? (
                        <Fragment>
                          <span className="team1-text29">Full name</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team1-thq-text-elm22 thq-body-small">
                      {props.member4Job ?? (
                        <Fragment>
                          <span className="team1-text13">Job title</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team1-thq-text-elm23 thq-body-small">
                    {props.member4Content ?? (
                      <Fragment>
                        <span className="team1-text23">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Suspendisse varius enim in eros elementum
                          tristique.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team1-thq-social-icons-elm4">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
              <div className="team1-thq-card-elm5">
                <img
                  alt={props.member5Alt}
                  loading="lazy"
                  src={props.member5Src}
                  className="thq-img-ratio-1-1 team1-thq-placeholder-image-elm5"
                />
                <div className="team1-thq-content-elm8">
                  <div className="team1-thq-title-elm5">
                    <span className="team1-thq-text-elm24 thq-body-small">
                      {props.member5 ?? (
                        <Fragment>
                          <span className="team1-text10">Full name</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team1-thq-text-elm25 thq-body-small">
                      {props.member5Job ?? (
                        <Fragment>
                          <span className="team1-text18">Job title</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team1-thq-text-elm26 thq-body-small">
                    {props.member5Content ?? (
                      <Fragment>
                        <span className="team1-text22">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Suspendisse varius enim in eros elementum
                          tristique.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team1-thq-social-icons-elm5">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
              <div className="team1-thq-card-elm6">
                <img
                  alt={props.member6Alt}
                  loading="lazy"
                  src={props.member6Src}
                  className="thq-img-ratio-1-1 team1-thq-placeholder-image-elm6"
                />
                <div className="team1-thq-content-elm9">
                  <div className="team1-thq-title-elm6">
                    <span className="team1-thq-text-elm27 thq-body-small">
                      {props.member6 ?? (
                        <Fragment>
                          <span className="team1-text20">Full name</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team1-thq-text-elm28 thq-body-small">
                      {props.member6Job ?? (
                        <Fragment>
                          <span className="team1-text25">Job title</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team1-thq-text-elm29 thq-body-small">
                    {props.member6Content ?? (
                      <Fragment>
                        <span className="team1-text17">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Suspendisse varius enim in eros elementum
                          tristique.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team1-thq-social-icons-elm6">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Team1.defaultProps = {
  member5: undefined,
  member1Content: undefined,
  member1Src:
    'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fHVzZXJ8ZW58MHx8fHwxNzEwOTQyNjEyfDA&ixlib=rb-4.0.3&w=600',
  member2: undefined,
  member4Job: undefined,
  member2Content: undefined,
  member3Content: undefined,
  member1Job: undefined,
  member6Content: undefined,
  member6Alt: 'Member Alt',
  member5Job: undefined,
  member4Alt: 'Member Alt',
  member4Src:
    'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE1fHx1c2VyfGVufDB8fHx8MTcxMDk0MjYxMnww&ixlib=rb-4.0.3&w=600',
  member2Alt: 'Member Alt',
  member3: undefined,
  member6: undefined,
  member2Src:
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDN8fHVzZXJ8ZW58MHx8fHwxNzEwOTQyNjEyfDA&ixlib=rb-4.0.3&w=600',
  member3Job: undefined,
  member5Content: undefined,
  member6Src:
    'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDV8fHVzZXJ8ZW58MHx8fHwxNzEwOTQyNjEyfDA&ixlib=rb-4.0.3&w=600',
  member4Content: undefined,
  member1Alt: 'Member Alt',
  heading1: undefined,
  titleAs: 'h2',
  member6Job: undefined,
  content2: undefined,
  member1: undefined,
  member3Src:
    'https://images.unsplash.com/photo-1639149888905-fb39731f2e6c?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE0fHx1c2VyfGVufDB8fHx8MTcxMDk0MjYxMnww&ixlib=rb-4.0.3&w=600',
  member5Alt: 'Member Alt',
  member2Job: undefined,
  member5Src:
    'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDR8fHVzZXJ8ZW58MHx8fHwxNzEwOTQyNjEyfDA&ixlib=rb-4.0.3&w=600',
  member3Alt: 'Member Alt',
  member4: undefined,
}

Team1.propTypes = {
  member5: PropTypes.element,
  member1Content: PropTypes.element,
  member1Src: PropTypes.string,
  member2: PropTypes.element,
  member4Job: PropTypes.element,
  member2Content: PropTypes.element,
  member3Content: PropTypes.element,
  member1Job: PropTypes.element,
  member6Content: PropTypes.element,
  member6Alt: PropTypes.string,
  member5Job: PropTypes.element,
  member4Alt: PropTypes.string,
  member4Src: PropTypes.string,
  member2Alt: PropTypes.string,
  member3: PropTypes.element,
  member6: PropTypes.element,
  member2Src: PropTypes.string,
  member3Job: PropTypes.element,
  member5Content: PropTypes.element,
  member6Src: PropTypes.string,
  member4Content: PropTypes.element,
  member1Alt: PropTypes.string,
  heading1: PropTypes.element,
  titleAs: PropTypes.string,
  member6Job: PropTypes.element,
  content2: PropTypes.element,
  member1: PropTypes.element,
  member3Src: PropTypes.string,
  member5Alt: PropTypes.string,
  member2Job: PropTypes.element,
  member5Src: PropTypes.string,
  member3Alt: PropTypes.string,
  member4: PropTypes.element,
}

export default Team1
